import React from 'react'

const loaderStyle = {
	display: 'flex',
	alignItems: 'center',
	justifyContent: 'center'
}

const spinnerStyle = {
	display: 'inline-block',
	width: '4rem',
	height: '4rem',
	border: '0.3rem solid rgba(36, 145, 130, 0.2)',
	borderTopColor: '#249182',
	borderRadius: '50%',
	animation: 'rotation 0.8s linear infinite'
}

const BVLoader = () => (
	<div className="loader" style={loaderStyle} role="status" aria-live="polite" aria-label="Loading">
		<span style={spinnerStyle} />
	</div>
)

export default BVLoader
